import { LogIn } from "react-feather";
import { Link } from "react-router-dom";
import { profileList } from "../../../data/layout/Header";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { logout } from "../../../reduxToolkit/reducers/layout/authSlice";
import { dynamicImage } from "../../../utils";
import { routes } from "../../../routers/routes";
import { LogOut } from "../../../constants";
import SvgIcon from "../../../coreComponents/SvgIcon";
import { Image } from "../../../coreComponents/Image";

const Profile = () => {
  const dispatch = useAppDispatch();
  return (
    <li className="profile-nav onhover-dropdown p-0 m-0">
      <div className="d-flex profile-media align-items-center">
        <Image className="b-r-6 img-40" src={dynamicImage(`dashboard/profile.png`)} alt="profile" />
        <div className="flex-grow-1">
          <span>Helen Walter</span>
          <p className="mb-0">
            Admin
            <SvgIcon iconId="header-arrow-down" />
          </p>
        </div>
      </div>
      <ul className="profile-dropdown onhover-show-div">
        {profileList.map((item) => (
          <li key={item.id}>
            <Link to={item.link}>
              {item.icon}
              <span>{item.text} </span>
            </Link>
          </li>
        ))}
        <li>
          <Link onClick={() => dispatch(logout())} to={routes.Login}>
            <LogIn />
            <span>{LogOut}</span>
          </Link>
        </li>
      </ul>
    </li>
  );
};
export default Profile;
